import { ships } from "@edcc/game-data";

const photoSlugs = new Set(ships.map((ship) => ship.slug));

export interface SiteShipArt {
  src: string;
  toon: false;
  accent: null;
}

/** Use only the supplied in-game ship photography on the showcase site. */
export function shipArtFor(slug: string | null | undefined): SiteShipArt | null {
  if (!slug || !photoSlugs.has(slug)) return null;
  return { src: `/ship-images/${slug}.webp`, toon: false, accent: null };
}
